export interface CouponDTO {
  code?: string;
  organization?: string;
  discount?: number;
  discountType?: CouponType;
  effectiveDate?: Date;
  expiryDate?: Date;
  segments?: Array<string>;
  customers?: Array<string>;
  affectedProducts?: Array<string>;
  affectedProductsMode?: 'include' | 'exclude';
  affectedCategories?: Array<string>;
  conditions?: ICouponConditions;
  maxCustomerRedemptions?: number;
  maxRedemptionsPerCustomer?: number; // Max times a single customer can redeem this coupon
  cycles?: number;
  firstOrderOnly?: boolean;
}

export class ICouponConditions extends Array<ICouponConditionsCriteria> {
  // If ANY of these inner items evaluates to true, the coupon applies
  // Each inner item is a set of AND conditions
}

interface ICouponConditionsCriteria {
  productsMode?: 'include' | 'exclude';
  products: Array<{ id: string; minQty: number }>;
  minCartValue: number;
  minCartProductsQty: number;
  categories: Array<{ id: string; minQty: number }>;
}

export interface ICoupon extends CouponDTO {
  _id: string;
  usageCount?: number;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface GetCouponsFilters {
  code?: string;
  customer?: string;
  effectiveDate?: string;
  expiryDate?: string;
  affectedProducts?: string;
  affectedProductsMode?: 'include' | 'exclude';
  affectedCategories?: string;
  discount?: number;
  discountType?: string;
}

export interface CouponResponse {
  coupon: ICoupon;
  error?: string;
}

export enum CouponType {
  PERCENT = 'percent',
  DOLLAR = 'dollar'
}
